import * as React from "react";
import {SVG} from "./widgets/SVG";
import {Photo} from "./Photo";


export const PhotoRendered = (props:{photo:Photo}) => {
    //const iconPhoto = new Photo( feedItem._post ? '/img/noun_video_quiz.svg' : (feedItem.icon?feedItem.icon:null) );
    let renderedAsIcon = <div className={'emptyIcon'} aria-hidden ></div>;
    if(props.photo.photoIsSVG) {
      renderedAsIcon = <SVG className={"svgIcon"} src={props.photo.photo} gradient title={""} aria-hidden />;
    } else if(props.photo.photoIsPNG || props.photo.photoIsJPG) {
      renderedAsIcon = <div className={"imgSmall"}><img src={props.photo.smallPhoto} alt={""}  aria-hidden /></div>;
    }
    return <div className={"photo-rendered"} aria-hidden>{renderedAsIcon}</div>;
}